import { Record } from 'immutable';

export const Filters = new Record({
  date_start: "",
  date_end: "",
  stateId: "",
  sessionId: null,
});
